export const auth = {
  signin_with_template: "Log in with %s",
  register_with_template: "Sign up with %s",
  email_and_password: "Email & Password",
  label_email: "E-mail address",
  label_password: "Password",
  label_current_password: "Current Password",
  label_new_password: "New Password",
  forgot_password: "Forgot password?",
  button_reset_password: "Reset Password",
  button_send_new_reset_link: "Send new password reset link",
  button_send_new_verification_link: "Send new email verification link",
  button_discard_invitation: "Discard invitation",
  button_switch_to_register: "Sign up instead",

  pw_error_digit: "Use at least one digit (0-9)",
  pw_error_lowercase: "Use at least one lowercase letter (a-z)",
  pw_error_uppercase: "Use at least one uppercase letter (A-Z)",
  pw_error_whitespace: "Do not use whitespace characters",
  pw_error_length: "Use minimum 8 characters",

  error_rate_limit_block: "Too many attempts, please wait 15 minutes.",
  reg_error_user_already_exist:
    "Email address already registered, try to log in instead",

  reg_error_google: "Unable to contact Google, please try again",
  reg_error:
    "We where unable to create the account at this time, please try again later",

  login_error_email_password_mismatch:
    "The account does not exist, or password does not match",
  login_error_email_not_verified:
    "The email address is not verified. Please open your email inbox and click on the email verification link.",
  login_error_google: "Unable to contact Google, please try again",
  login_error_google_not_registered: "Account not found, sign up instead?",
  login_error:
    "We where unable to sign you in at this time, please try again later",

  email_verify_head_failed: "Verifying Email Failed",
  email_verify_head: "Verifying Email",
  email_verify_token_error:
    "Email verification code is missing or has incorrect format, please check your link",
  email_verify_succeded: "Email address is now verified",
  email_verify_failed:
    "We were unable to verify email address. Please check your link.\nOr maybe it was already verified?",

  trigger_pw_reset_head: "Password Reset",
  trigger_pw_reset_response:
    "If the email address was found, an email has now been sent containing a password reset link.\n\nMaximum 5 emails can be sent during 24 hours.",
  trigger_pw_reset_error:
    "We where unable to reset your password at this time, please try again later",
  trigger_pw_reset_error_rate_limit:
    "To many emails sent, try again in 15 minutes.",
  trigger_pw_reset_error_rate_limit_24h:
    "To many emails sent, try again in 24 hours.",

  pw_reset_head: "Password Reset",
  pw_reset_response:
    "Your password is now updated. You can now sign in with your email and new password.",
  pw_reset_error:
    "We where unable to reset your password. Did you enter the correct email address, or perhaps the password link has expired?",

  reset_password_head: "Reset Password",
  reset_password:
    "Reset you password by submitting your email address and the new password you would like to have.",

  invitation_head: "Invitation to join account",
  invitation_text_template:
    "You have been invited to join the account: %s\nPlease register below",

  invitation_error_head: "Invitation not found",
  invitation_error_text:
    "The invitation in your link has been deleted or is already claimed.\n\nDo you want to discard the invitation\nand register a new account instead?",

  head_onelink_referrer: "Hi there, are you trying to download an app?",
  onelink_referrer_info: "I see that you came here after clicking on a onelink.to link or scanning a QR code.\n\nIf you are trying to download an app, then you do not need to create an account.\n\nAccounts are used to create new download links och QR codes for your own app."
};
